import { DatePipe, Location } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgOtpInputComponent, NgOtpInputConfig } from 'ng-otp-input';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { ExitingpatientService } from 'src/app/services/exitingpatient.service';
import { RegistorpatientService } from 'src/app/services/registorpatient.service';
import { VerifypatientService } from 'src/app/services/verifypatient.service';
import { PatientPersonalInfo, VerifypatientModule, getPatientDataByURl } from 'src/app/models/verifypatient/verifypatient';
import { UpdateinfoService } from '../../services/updateinfo.service';
import { addAppointmentRequest, serviceAppointmentTimeSlotModel } from 'src/app/models/appointment/appointment';
import { AppointmentService } from 'src/app/services/appointment.service';
import moment from 'moment';
import { PaymentService } from 'src/app/services/payment.service';
import { PaymentDeiails } from '../../models/registeration/payment_models';
import { Registration } from '../../models/login/login';
import { ReferralService } from '../../services/referral.service';
import { GenericUtilityService } from '../../generic/generic-utility.service';
declare var $: any;
@Component({
  selector: 'app-exitingpatientlogin',
  templateUrl: './exitingpatientlogin.component.html',
  styleUrls: ['./exitingpatientlogin.component.css']
})
export class ExitingpatientloginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup = new FormGroup({});
  first_name: any;
  last_Name: any;
  Dob: any;
  maxDate: any;
  practice_phone: any;
  practice_name: any;
  patientpersonalinfo: any;
  curDate = new Date();
  flowType = '';
  selectedDay: any;
  selectedMonth: any;
  selectedYear: any;
  months: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  years: number[] = [];
  encryptedPracticeCode: any
  getPatientInfo: getPatientDataByURl = new getPatientDataByURl();
  VerifypatientModule: VerifypatientModule;
  PatientPersonalInfo: PatientPersonalInfo;
  selectedLanguage: any = 'en';
  isLockScreen: boolean = false;
  showDOBForCheckin: boolean = true;
  addAppointmentRequest: addAppointmentRequest = new addAppointmentRequest();
  currentTimeZoneOffSet: any;
  appointmentSlots: any;
  selectedSlot: any;
  availableDate: any;
  availableSlot: any;
  appointment_type: any;
  daysInMonth: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
  isValidEmail: boolean = true;
  isNotCellPhone: boolean = false;
  isNotValidPhone: boolean = false;
  isShowVerifyButton: boolean = false;
  practice_code: any;
  selectedProviderName: string = '';
  isFirstAvailableDate: boolean = false;
  registration: any;
  formattedDate: any;
  providername = '';
  providerCode: any;
  isWaitlist: any;
  isDrsite: boolean = false
  isDrsiteCheckoutNotes: boolean = false
  isDrsiteIntake: boolean = false
  isForLabOrder: boolean = false;
  IslandeFromQRCode: boolean = false;
  dropdownValues: any;
  labOrderResponse: any;
  loginResp: any = null;
  date_of_birth: any
  showModal: boolean = false;
  isMinuDueAmount: string = "false";
  isMinuTotalAmount: string = "false";
  paymentDetials: PaymentDeiails = new PaymentDeiails();
  amountDueTemp: Number;
  isCopay: any = false;
  isoutstanding: any = false;
  ShowAmountField: boolean = true;
  phoneLink: any;
  patientLanguage: any;
  increment: any = 0;
  isWithin24Hours: any;
  isWithin3Hours: any;
  linkType: string;
  otpResp: any = null;
  isSendingOTP: boolean = false;
  verResp: any = null;
  otpEntered: boolean = true;
  otp: string = '';
  isVerifying: boolean = false;
  //otp timer starts
  m: string = '00';
  s: string = '00';
  timer: any;
  remainingTime: number = 1;
  ObjAction: any = {};
  RegistrationResponce: any;
  isScanLicense: any = false;
  isDob: any = true;
  fileObjFront: any;
  isFrontPhotoUpload: boolean = false;
  defaultImagefront: any;
  isDobChecked: boolean = false;
  constructor(private translateService: TranslateService, private spinner: NgxSpinnerService, private _phrutilService: PhrutillsService, private _login: ExitingpatientService, private datepipe: DatePipe, private _genericService: GenericUtilityService,
    private _router: Router, private _route: ActivatedRoute, private _registor: RegistorpatientService, private location: Location, private _VerifypatientService: VerifypatientService, private updateinfoservice: UpdateinfoService, private service: PaymentService, private phrUtils: PhrutillsService, private appoint: AppointmentService,
    private referralService: ReferralService) {
    let info = localStorage.getItem('PatientInfo');
    if (!info) {
      this._router.navigateByUrl("/home?practice_code=''");
      return;
    }
    this.reset();
    this.registration = new Registration();
    this.maxDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this._route.queryParams.subscribe((param) => {
      if (param.type) {
        this.flowType = param.type;
        this.isFirstAvailableDate = param.isFirstAvail
        console.log('flowtype', this.flowType)
        //console.log('isFirstAvailableDate', this.isFirstAvailableDate)
        this.buildregistrationForm();
        if (this.flowType == 'appointment') {
          this._phrutilService.patientlanguage$.subscribe(language => {
            //console.log("dafault " + language);
            if (language === 'es') {
              this._phrutilService.setTitle('Reservar una cita');
            } else if (language === 'hi') {
              this._phrutilService.setTitle('अपॉइंटमेंट बुक करें');
            } else if (language === 'ur') {
              this._phrutilService.setTitle('اپوائنٹمنٹ بک کریں');
            } else if (language === 'gu') {
              this._phrutilService.setTitle('એપોઇન્ટમેન્ટ બુક કરો');
            }
            else {
              this._phrutilService.setTitle('Book an Appointment');
              /*this._phrutilService.setTitle('Tell us a bit about you');*/
            }
          });
        } else if (this.flowType == 'laborder') {
          this.removeNameValidation();
          this.isForLabOrder = true;
          this._phrutilService.setTitle('Verify Patient');
        }
        else {
          this._phrutilService.patientlanguage$.subscribe(language => {
            //console.log("dafault " + language);
            if (language === 'es') {
              this._phrutilService.setTitle('Pagar el saldo adeudado');
            } else if (language === 'hi') {
              this._phrutilService.setTitle('बकाया राशि का भुगतान करें');
            } else if (language === 'ur') {
              this.phrUtils.setTitle('بقایا بیلنس ادا کریں');
            } else if (language === 'gu') {
              this.phrUtils.setTitle('બાકી બેલેન્સ ચૂકવો');
            }
            else {
              this._phrutilService.setTitle('Pay Due Balance');
            }
          });
        }
      } else {
        // this.isNameFieldsEnabledForCheckin = false;
        // this.removeNameValidation();
        // //console.log("name field", this.isNameFieldsEnabledForCheckin);
        this.updateFlowValidation('name');
        this._phrutilService.patientlanguage$.subscribe(language => {
          //console.log("dafault " + language);
          if (language === 'es') {
            this._phrutilService.setTitle('Regístrese para una cita');
          } else if (language === 'hi') {
            this._phrutilService.setTitle('अपॉइंटमेंट के लिए चेक-इन करें');
          } else if (language === 'ur') {
            this._phrutilService.setTitle('اپوائنٹمنٹ کے لیے چیک ان کریں');
          } else if (language === 'gu') {
            this._phrutilService.setTitle('એપોઇન્ટમેન્ટ માટે ચેક-ઇન કરો');
          }
          else {
            this._phrutilService.setTitle('Check-in for Appointment');
          }
        });
      }
    });
    this.selectedSlot = new serviceAppointmentTimeSlotModel();

  }

  buildregistrationForm() {
    this.loginForm = new FormGroup({
      firstname: new FormControl('', [
        Validators.required,
        Validators.maxLength(35),
        Validators.pattern('^[a-zA-Z ]*$')
      ]),
      lastname: new FormControl('', [
        Validators.required,
        Validators.maxLength(35),
        Validators.pattern('^[a-zA-Z ]*$')
      ]),
      dobDay: new FormControl('', [Validators.required]),
      dobMonth: new FormControl('', [Validators.required]),
      dobyear: new FormControl('', [Validators.required]),
      email: new FormControl(''),
      cell: new FormControl(''),
      EmailAddress: new FormControl(''),
      cellPhone: new FormControl('', [
        Validators.pattern('^[0-9]*$')
      ])
    });

    if (this.flowType === 'appointment') {
      this.loginForm.get('email')?.setValidators([Validators.required, Validators.email]);
      this.loginForm.get('cell')?.setValidators([Validators.required, Validators.minLength(10)]);
    } else {
      // Optional: clear validators if not 'appointment'
      this.loginForm.get('email')?.clearValidators();
      this.loginForm.get('cell')?.clearValidators();
    }

    // Update validation status after setting validators
    this.loginForm.get('email')?.updateValueAndValidity();
    this.loginForm.get('cell')?.updateValueAndValidity();
  }
  trackPatientPreference(lf: any) {
    //console.log("landed from ", lf);
    this.ObjAction['patientAccount'] = this.getPatientInfo.patientAccount;
    this.ObjAction['practiceCode'] = this.getPatientInfo.practiceCode;
    this.ObjAction['appointmentID'] = this.getPatientInfo.appointment_id;
    this.ObjAction['action'] = lf;
    this.ObjAction['createdBy'] = this.getPatientInfo.firstName + " " + this.getPatientInfo.lastName;
    this.ObjAction['appSource'] = "breezeCheckin";
    //console.log("action object ", this.ObjAction);
    this._VerifypatientService.ManageActionItems(this.ObjAction).subscribe((res: any) => {
      //console.log(res);
    }, (error: any) => {
      //console.log(error);
    })
  }
  get getloginForm() {
    return this.loginForm.controls;
  }

  updateFlowValidation(flowType: string) {

    if (flowType != 'name') {
      console.log("flow type",flowType);
      this.loginForm.addValidators(this.emailOrCellRequiredValidator);

    } else {

      this.loginForm.removeValidators(this.emailOrCellRequiredValidator);

    }

    this.loginForm.updateValueAndValidity();
  }

  emailOrCellRequiredValidator: ValidatorFn =
    (control: AbstractControl): ValidationErrors | null => {

      const EmailAddress = control.get('EmailAddress');
      const cellPhone = control.get('cellPhone');

      // ⚠️ Important: Agar fields exist hi nahi karti to validation skip
      if (!EmailAddress || !cellPhone) return null;

      if (!EmailAddress.value && !cellPhone.value) {
        return { emailOrCellRequired: true };
      }

      return null;
    };

  enableNameValidation() {
   // console.log('enable name');
    //this.isNameFieldsEnabledForCheckin = true; 
    this.loginForm.controls['firstname'].setValidators([Validators.required, Validators.maxLength(35), Validators.pattern('^[a-zA-Z ]*$')]);
    this.loginForm.controls['lastname'].setValidators([Validators.required, Validators.maxLength(35), Validators.pattern('^[a-zA-Z ]*$')]);
    // this.loginForm.controls['firstname'].updateValueAndValidity();
    //  this.loginForm.controls['lastname'].updateValueAndValidity();
  }
  removeNameValidation() {
  //  console.log('remove validation anme');
    this.loginForm.controls['firstname'].clearValidators();
    this.loginForm.controls['lastname'].clearValidators();
  }
  reset() {
    this.loginForm.reset();
    this.buildregistrationForm();
  }
  ngOnInit(): void {
    //console.log('flowtype', this.flowType)
    const isWaitlist = localStorage.getItem('isWaitlist');
    //console.log('isWaitlist retrieved in ExitingPatientLoginComponent:', isWaitlist);
    if (isWaitlist !== null) {
      this.isWaitlist = JSON.parse(isWaitlist);
      //console.log('isWaitlist retrieved in ExitingPatientLoginComponent:', this.isWaitlist);
    }
    const landfrom = localStorage.getItem("landFrom");
    if (landfrom != undefined && landfrom != null && landfrom == 'qrcode') {
      this.IslandeFromQRCode = true;
      this._phrutilService.setTitle('Verify Patient');
    }

    if (landfrom == 'drsite') {
      this.isDrsite = true;
    }
    if (landfrom == 'drsiteintake') {
      this.isDrsiteIntake = true;
    }
    if (landfrom == 'checkoutnotes') {
      this.isDrsiteCheckoutNotes = true;
      this.loginForm.get('email')?.clearValidators();
      this.loginForm.get('cell')?.clearValidators()
      // Update validation status after setting validators
      this.loginForm.get('email')?.updateValueAndValidity();
      this.loginForm.get('cell')?.updateValueAndValidity();

    } else {
      this.isDrsiteCheckoutNotes = false;
    }
    this.populateYears();
    this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PatientInfo'));
    ////console.log('PatientPersonalInfo Data', this.patientpersonalinfo);
    ////console.log('PatientPersonalInfo Data patientAccount', this.patientpersonalinfo.patientAccount);
    this._phrutilService.setNavpracName(this.patientpersonalinfo.prac_Name);
    if (this.patientpersonalinfo.practicePhone) {
      this.phoneLink = "tel:+1" + this.patientpersonalinfo.practicePhone;
      this.practice_phone = this._phrutilService.maskingPhoneNumer(this.patientpersonalinfo.practicePhone);
    }
    this._phrutilService.dropdownValues$.subscribe(values => {
      this.dropdownValues = values;
      //console.log('provider', this.dropdownValues)

      if (values.provider && values.provider.providerName) {
        this.selectedProviderName = values.provider.providerName;
      }
    });
    const storedValues = localStorage.getItem('dropdownValues');
    if (storedValues) {
      const parsedValues = JSON.parse(storedValues);
      if (parsedValues.provider && parsedValues.provider.providerName) {
        this.selectedProviderName = parsedValues.provider.providerName;
      }
    }
    if (this.isDrsite || this.isDrsiteCheckoutNotes || this.isDrsiteIntake) {

      this.providername = localStorage.getItem('selectedProviderName');
    }
    else {
      //this.providername = localStorage.getItem("selectedProvider");
      const storedProvider = localStorage.getItem('selectedProvider');
      ////console.log('providers: ', storedProvider)
      if (storedProvider) {
        const parsedProvider = JSON.parse(storedProvider); // Parse the JSON string
        this.providername = parsedProvider.providerName; // Extract only the name
      }
    }
    //console.log("Provider Name in ExitingpatientloginComponent:", this.providername);
    this.availableDate = localStorage.getItem('selectedSlotavailableDate');
    this.availableSlot = localStorage.getItem('selectedSlotavailableSlot');
    this.appointment_type = localStorage.getItem('appointment_type');
    this.currentTimeZoneOffSet = localStorage.getItem('currentTimeZoneOffSet');
    this.providerCode = JSON.parse(localStorage.getItem('selectedProviderCode'));
    const from = localStorage.getItem("from");
    if (from != undefined && from != null) {
      if (from == 'nolabfound') {
        console.log("no lab found");
        $("#noLabFoundModal").modal("show");
        localStorage.removeItem("from");
      }
      // else if (from == 'usernotmatched') {
      //   setTimeout(() => {
      //     $("#isNotValid_linkexiting").modal("show");
      //     localStorage.removeItem("from");
      //   }, 300)
      // }

    }
    this.GetPatientDetailsByLabID();
    //this.getTokenForDataScience();
  }
  ngAfterViewInit() {
    // care-team/symptoms-checker DS dependency, currently unused - uncomment if those are reactivated
    // this.getTokenForDataScience();
  }
  // getLabOrderDetails(labid: any) {
  //   this.spinner.show();
  //   this.referralService.GetLabOrderDetails(labid).subscribe((res: any) => {
  //     this.spinner.hide();
  //     if (res.data.patient_order_id) {
  //       this.labOrderResponse = res.data;
  //       if (this.labOrderResponse.patient_account !== this.patientpersonalinfo.patient_Account) {
  //         console.log("not matched");
  //         $("#isNotValid_linkexiting").modal("show");
  //       } else {
  //         console.log("matched");
  //         this._router.navigateByUrl('/plab');
  //       }
  //     } else {
  //       $("#noLabFoundModal").modal("show");
  //     }

  //   }, (error: any) => {
  //     this.spinner.hide();
  //     let text = "Service is not available, please try later.";
  //     this._phrutilService.showError(text);
  //   });
  // }
  isName: boolean = true;
  isCell: boolean = false;
  ChangeCheckinType(type: any) {
    if (type == 'scan') {
      this.isDob = false;
      this.isName = false;
      this.isCell = false;
      this.isScanLicense = true;
      //this.isDobChecked = false;
    }
    else if (type == 'name') {
      this.reset();
      this.isDob = true;
      this.isName = true;
      this.isCell = false;
      this.isScanLicense = false;
      this.updateFlowValidation('name');
      this.enableNameValidation();
    } else if (type == 'cell') {
      this.reset();
      this.isDob = true;
      this.isCell = true;
      this.isName = false;
      this.isScanLicense = false;
      this.updateFlowValidation('cell');
      this.removeNameValidation();
    }
  }
 
  onChangeFileFront(event: any) {
    this.fileObjFront = event.target.files[0];
    if (this.fileObjFront) {
      this.showPreview(event, 'front');
      // this.isRequireFrontCard = false;
      event.target.value = '';
      this.OCRDrivingLicenseService();
    }
    else {
      // this.isRequireFrontCard = true;
      return;
    }
  }
  //show local image
  showPreview(event: Event, type: any) {
    let selectedFile = (event.target as HTMLInputElement).files?.item(0)
    if (selectedFile) {
      if (["image/jpeg", "image/png", "image/svg+xml", "image/gif"].includes(selectedFile.type)) {
        let fileReader = new FileReader();
        fileReader.readAsDataURL(selectedFile);
        fileReader.addEventListener('load', (event) => {
          console.log("front");
          this.isFrontPhotoUpload = true;
          this.defaultImagefront = event.target?.result;
        })
      }
    }
  }
 
  OCRDrivingLicenseService() {
    this._phrutilService.setChekcinType("scan");
    // console.log(this.isRequireFrontCard);
    // console.log(this.fileObjFront);
    this.spinner.show();
    this._VerifypatientService.OcrDrivingLicense(this.fileObjFront).subscribe((res: any) => {
      this.spinner.hide();
      //  console.log("ins name ",);
      // $("#Captured-Modal").modal("hide");
      //console.log("OCR Result ", res);
      if (res && res.Data != null) {
        if (res.iv) {
          res.Data["License #"] = res.Data["License #"] ? this._phrutilService.decryptforDrivingLicense(res.Data["License #"], res.iv) : res.Data["License #"];
          res.Data["First Name"] = res.Data["First Name"] ? this._phrutilService.decryptforDrivingLicense(res.Data["First Name"], res.iv) : res.Data["First Name"];
          res.Data["Middle Name"] = res.Data["Middle Name"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Middle Name"], res.iv) : res.Data["Middle Name"];
          res.Data["Last Name"] = res.Data["Last Name"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Last Name"], res.iv) : res.Data["Last Name"];
          res.Data["DOB"] = res.Data["DOB"] ? this._phrutilService.decryptforDrivingLicense(res.Data["DOB"], res.iv) : res.Data["DOB"];
          res.Data["City"] = res.Data["City"] ? this._phrutilService.decryptforDrivingLicense(res.Data["City"], res.iv) : res.Data["City"];
          res.Data["State"] = res.Data["State"] ? this._phrutilService.decryptforDrivingLicense(res.Data["State"], res.iv) : res.Data["State"];
          res.Data["Zip Code"] = res.Data["Zip Code"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Zip Code"], res.iv) : res.Data["Zip Code"];
          res.Data["Issue Date"] = res.Data["Issue Date"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Issue Date"], res.iv) : res.Data["Issue Date"];
          res.Data["Expiry Date"] = res.Data["Expiry Date"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Expiry Date"], res.iv) : res.Data["License #"];
          res.Data["Gender"] = res.Data["Gender"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Gender"], res.iv) : res.Data["Gender"];
          res.Data["Class"] = res.Data["Class"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Class"], res.iv) : res.Data["Class"];
          res.Data["Address"] = res.Data["Address"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Address"], res.iv) : res.Data["Address"];
          res.Data["Complete Address"] = res.Data["Complete Address"] ? this._phrutilService.decryptforDrivingLicense(res.Data["Complete Address"], res.iv) : res.Data["Complete Address"];
          //console.log("licenseNo", res.Data["License #"]);
          if (res && res.Data["License #"] != "Null" && res.Data["License #"] != "" && res.Data["DOB"] != "Null" && res.Data["DOB"] != "" && res.Data["First Name"] !="" && res.Data["Last Name"] !="") {
            this.onSubmitbyCard(res.Data["DOB"], res.Data["First Name"], res.Data["Last Name"]);
            let data = this._phrutilService.encrypt(res);
            localStorage.setItem('licensedata', data);
            //console.log(res);
          }
          else {
            //unable to scan card
            this.isDobChecked = true;
            $("#scanFail-model").modal("show");
            //console.log(res)
          }
        } else {
          if (res && res.Data["License #"] != "Null" && res.Data["License #"] != "" && res.Data["DOB"] != "Null" && res.Data["DOB"] != "") {
            this.onSubmitbyCard(res.Data["DOB"], res.Data["First Name"], res.Data["Last Name"]);
            let data = this._phrutilService.encrypt(res);
            localStorage.setItem('licensedata', data);
          }
          else {
            //unable to scan card
            this.isDobChecked = true;
            $("#scanFail-model").modal("show");
          }
        }


      } else {
        //return null
        this.isDobChecked = true;
        $("#scanFail-model").modal("show");
      }
    }, (error: any) => {
      this.spinner.hide();
      this.isDobChecked = true;
      $("#scanFail-model").modal("show");
    })
  }
  onSubmitbyCard(dob: any, Fname: any, Lname: any) {
    if (this.flowType == "") {
      console.log("new API hit");
      this.getPatientData(this.patientpersonalinfo.practice_Code, Fname, Lname, dob, "scan");
    } else {
      console.log("old API hit");
      this.getPatientdataOther(dob, Fname, Lname);
    }
  }
  getPatientdataOther(dob: any, Fname: any, Lname: any) {
    this.spinner.show();
    this._login.VerifyExistingPatientByNameDob(Fname, Lname, dob, this.patientpersonalinfo.practice_code).subscribe((res: any) => {
      this.spinner.hide();
      if (res.statusCode == 200 && res.data.status.toLowerCase() == 'success') {
        this.loginResp = res.data;
        //this.SendOTP();
        this.patientpersonalinfo.date_Of_Birth = this.loginResp.date_Of_Birth;
        this.patientpersonalinfo.email_Address = this.loginResp.email_Address;
        this.patientpersonalinfo.cell_phone = this.loginResp.cell_phone;
        this.patientpersonalinfo.first_Name = this.loginResp.first_Name;
        this.patientpersonalinfo.last_Name = this.loginResp.last_Name;
        this.patientpersonalinfo.practice_Code = this.loginResp.practice_Code;
        this.patientpersonalinfo.prac_Name = this.loginResp.prac_Name;
        this.patientpersonalinfo.patient_Account = this.loginResp.patient_Account;
        this.patientpersonalinfo.prac_Phone = this.loginResp.prac_Phone;
        this.patientpersonalinfo.gender = this.loginResp.gender;
        let data = this._phrutilService.encrypt(this.patientpersonalinfo);
        localStorage.setItem("AuthTokenwebServices", this.loginResp.accessTokenResponse.accessToken);
        localStorage.setItem("RefreashTokenwebServices", this.loginResp.accessTokenResponse.refreshToken);
        localStorage.setItem('PatientInfo', data);
        if (this.patientpersonalinfo.type == 'walkin') {
          //this._router.navigateByUrl("/exitingappointment")
          this.onAddScheduleAppointment()
        }
        else if (this.patientpersonalinfo.type == 'check-in') {
          this.getCheckinDetails(this.patientpersonalinfo.practice_Code, this.patientpersonalinfo.patient_Account);
        }
        else if (this.patientpersonalinfo.type == 'payment') {
          this.getPaymentDetails();
        }
      }
      else if (res.data.status.toLowerCase() == 'no record found') {
        this.isDobChecked = true;
        $("#incorrectinfoLicense-model").modal("show");
        localStorage.removeItem('licensedata');
        return;
      }
      else if (res.data.status.toLowerCase() == 'more then one patient exit with these info') {
        $("#ismorethenonepatient").modal("show");
        return;
      }
    }, (error: any) => {
      this.isDobChecked = true;
      $("#incorrectinfoLicense-model").modal("show");
      localStorage.removeItem('licensedata');
      this.spinner.hide();
      return;
    });
  }

  populateYears(): void {
    const currentYear = new Date().getFullYear();
    /*const startYear = currentYear - 100;*/
    const startYear = 1900;
    const endYear = currentYear;

    for (let i = endYear; i >= startYear; i--) {
      this.years.push(i);
    }
  }
  ValidatePersonalInfo(data: any, type: any) {

    let validname = data.target.value.replace(/[^a-zA-Z ]/g, "");
    data.target.value = validname;
    if (type == 'firstname') {
      if (validname != '') {
        this.first_name = validname;
      } else {
        this.first_name = validname;
      }
    } else if (type == 'lastname') {
      if (validname != '') {
        this.last_Name = validname;
      }
      else {
        this.last_Name = validname;
      }
    }
  }
  updateDays(event: any) {

    const selectedDay = this.loginForm.controls['dobDay'].value;
    //console.log(selectedDay);
    this.selectedMonth = parseInt(this.loginForm.controls['dobMonth'].value, 10);
    this.selectedYear = parseInt(this.loginForm.controls['dobyear'].value, 10) || new Date().getFullYear();

    if (this.selectedMonth) {
      //console.log("inside update days");
      const daysInSelectedMonth = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
      //console.log(daysInSelectedMonth);
      this.daysInMonth = Array.from({ length: daysInSelectedMonth }, (_, i) => i + 1);
      if (selectedDay != '') {
        if (selectedDay > daysInSelectedMonth) {
          this.loginForm.controls['dobDay'].setValue('');
        } else {
          this.loginForm.controls['dobDay'].setValue(selectedDay);
        }
      }

    } else {
      this.daysInMonth = Array.from({ length: 31 }, (_, i) => i + 1);
    }
  }
  onSelectSlot(event: any, slot: any) {
    let i = 0;
    this.appointmentSlots.map((res: any) => {
      $('[id="slot' + i + '"]').removeClass('active');
      i++;
    }
    );
    this.selectedSlot = slot;
    $('[id="' + event.target.id + '"]').addClass('active');
  }
  onAddScheduleAppointment() {
    //console.log('Inside ScheduleAppointment')
    //console.log("Dropdown1", this.dropdownValues.dropdown1)
    //console.log("Dropdown2", this.dropdownValues.dropdown2)
    //console.log("Dropdown3", this.dropdownValues.dropdown3)
    //console.log("availableSlot", this.availableSlot)
    //console.log("availableDate", this.availableDate)
    //console.log("appointment_type", this.appointment_type);
    //console.log("currentTimeZoneOffSet", this.currentTimeZoneOffSet);
    //console.log("patientpersonalinfo", this.patientpersonalinfo.patientAccount);
    //console.log("PracticeCode", this.patientpersonalinfo.practice_Code);
    //console.log("PROVIDERCode", this.providerCode);
    const dobDay = this.loginForm.controls['dobDay'].value;
    const dobMonth = this.loginForm.controls['dobMonth'].value;
    const dobYear = this.loginForm.controls['dobyear'].value;
    this.formattedDate = dobMonth + "/" + dobDay + "/" + dobYear;

    if (!this.loginForm.invalid && this.availableSlot != null && this.availableDate != null) {
      let Obj_addScheduleAppointmentModel = new addAppointmentRequest();
      Obj_addScheduleAppointmentModel.first_Name = this.loginForm.controls['firstname'].value;
      Obj_addScheduleAppointmentModel.last_Name = this.loginForm.controls['lastname'].value;
      Obj_addScheduleAppointmentModel.dateofBrith = this.formattedDate;
      if (this.isDrsiteCheckoutNotes) {
        Obj_addScheduleAppointmentModel.email = this.patientpersonalinfo.email_Address ? this.patientpersonalinfo.email_Address : this.patientpersonalinfo.cell_phone;
        Obj_addScheduleAppointmentModel.phone = this.patientpersonalinfo.cell_phone ? this.patientpersonalinfo.cell_phone : '"1111111111"'
      } else {
        Obj_addScheduleAppointmentModel.email = this.loginForm.controls['email'].value//this.patientpersonalinfo.email_Address ? this.patientpersonalinfo.email_Address : this.patientpersonalinfo.cell_phone;
        Obj_addScheduleAppointmentModel.phone = this.loginForm.controls['cell']!.value.replace(/\D/g, '');
      }
      //  Obj_addScheduleAppointmentModel.phone = this.loginForm.controls['cell']!.value.replace(/\D/g, '');
      Obj_addScheduleAppointmentModel.app_ReasonId = this.dropdownValues.reason.id;
      Obj_addScheduleAppointmentModel.location_Code = this.dropdownValues.location.id;
      Obj_addScheduleAppointmentModel.provider_Code = (this.isDrsite || this.isDrsiteCheckoutNotes || this.isDrsiteIntake) ? this.providerCode : this.dropdownValues.provider.providerCode;
      Obj_addScheduleAppointmentModel.practice_code = this.patientpersonalinfo.practice_Code;
      Obj_addScheduleAppointmentModel.patient_Account = this.patientpersonalinfo.patient_Account;
      Obj_addScheduleAppointmentModel.teleMedicine_Session = this.appointment_type == 'office' ? '0' : '1';
      Obj_addScheduleAppointmentModel.app_date = this.availableDate;
      Obj_addScheduleAppointmentModel.client_IP = sessionStorage.getItem('IP') ? sessionStorage.getItem('IP') : '';
      Obj_addScheduleAppointmentModel.patTimeZone = this.currentTimeZoneOffSet;
      Obj_addScheduleAppointmentModel.time_From = this.availableSlot.replace(/"/g, '').trim();
      Obj_addScheduleAppointmentModel.isConsentForm = '0';
      //Obj_addScheduleAppointmentModel.appSource = this.isDrsite || this.isDrsiteIntake ? 'Drsite' : 'breezeCheckin';
      if (this.isDrsiteCheckoutNotes) {
        Obj_addScheduleAppointmentModel.appSource = 'drsiteRecallAppt';
      } else if (this.isDrsite || this.isDrsiteIntake) {
        Obj_addScheduleAppointmentModel.appSource = 'drsite';
      } else {
        Obj_addScheduleAppointmentModel.appSource = 'breezeCheckin';
      }
      ////console.log("Obj_addScheduleAppointmentModel", Obj_addScheduleAppointmentModel);
      //return
      this.spinner.show();

      if (this.isWaitlist) {
        Obj_addScheduleAppointmentModel.is_WaitList = this.isWaitlist
        this.appoint.addWaitListAppointment(Obj_addScheduleAppointmentModel).subscribe((res: any) => {
          this.spinner.hide();
          //console.log('Response from addWaitListAppointment:', res);
          if (res.message.toLowerCase() == "success" && res.statusCode == 200) {
            if (res.data.isAppointmentInserted.toLowerCase() == "true") {
              let text = "Appointment has been scheduled successfully";
              this.translateService.get('Alerts.appointment_successfull').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showSuccess(text);
              // this._phrutilService.showSuccess(res.data.finalMessage);
              this.patientpersonalinfo.appointmentid = res.data.appointmentId;
              let data = this._phrutilService.encrypt(this.patientpersonalinfo);
              //console.log('DATA', data)
              localStorage.setItem('PatientInfo', data);
              this._router.navigateByUrl('/appoin-mes');
            } else {
              if (res.data.finalMessage === "You already have an appointment for this day. In case of any issue please contact provider office.") {
                this.translateService.get('Appointment.appointment_already_exist_for_the_day').subscribe((translation: string) => {
                  let text = translation;
                  this._phrutilService.showInfo(text);
                });

              } else if (res.data.finalMessage === "You can make only one appointment in 14 days. In case of any issue please contact provider office.") {
                this.translateService.get('Appointment.appointment_14_day_check').subscribe((translation: string) => {
                  let text = translation;
                  this._phrutilService.showInfo(text);
                });
              }
              else {
                this._phrutilService.showInfo(res.data.finalMessage);
              }
              //this._phrutilService.showInfo(res.data.finalMessage);
            }
          } else {
            let text = "Service is not available, please try later.";
            this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showError(text);
            //this._phrutilService.showError("Service is not available, please try later.");
          }
        },
          (error: any) => {
            this.spinner.hide(); let text = "Service is not available, please try later.";
            this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showError(text);
            //this._phrutilService.showError("Service is not available, please try later.");
          });
      } else {
        Obj_addScheduleAppointmentModel.is_WaitList = '0';
        this.appoint.addScheduleAppointment(Obj_addScheduleAppointmentModel).subscribe((res: any) => {

          this.spinner.hide();

          if (res.message.toLowerCase() == "success" && res.statusCode == 200) {
            if (res.data.isAppointmentInserted.toLowerCase() == "true") {
              let text = "Appointment has been scheduled successfully";
              this.translateService.get('Alerts.appointment_successfull').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showSuccess(text);
              // this._phrutilService.showSuccess(res.data.finalMessage);
              this.patientpersonalinfo.appointmentid = res.data.appointmentId;
              let data = this._phrutilService.encrypt(this.patientpersonalinfo);
              //console.log('DATA', data)
              localStorage.setItem('PatientInfo', data);
              // if (!this.isDrsiteIntake && !this.isDrsite) {
              if (!this.isDrsiteIntake) {
                //console.log("navigating to appoin-mes");
                this._router.navigateByUrl('/appoin-mes');
              }
              // else if (this.loginForm.valid && this.isDrsiteIntake || this.isDrsite) {
              else if (this.loginForm.valid && this.isDrsiteIntake) {
                const dobDay = this.loginForm.controls['dobDay'].value;
                const dobMonth = this.loginForm.controls['dobMonth'].value;
                const dobYear = this.loginForm.controls['dobyear'].value;
                this.formattedDate = dobMonth + "/" + dobDay + "/" + dobYear;
                //console.log("formated date ", this.formattedDate);
                const firstname = this.loginForm.controls['firstname'].value;
                const lastname = this.loginForm.controls['lastname'].value;
                //const result = localStorage.getItem('pcode')
                //const encryptedPracticeCode = this._phrutilService.encrypt(result);
                //console.log("new API hit");
                // this.getPatientData("DKaCtphNcNUv0Zud0xh3hA==", firstname, lastname, formattedDate);
                this.getPatientData(this.patientpersonalinfo.practice_Code, firstname, lastname, this.formattedDate,"Dob");
              } else {
                this.loginForm.markAllAsTouched();
              }

            } else {
              if (res.data.finalMessage === "You already have an appointment for this day. In case of any issue please contact provider office.") {
                this.translateService.get('Appointment.appointment_already_exist_for_the_day').subscribe((translation: string) => {
                  let text = translation;
                  this._phrutilService.showInfo(text);
                });

              } else if (res.data.finalMessage === "You can make only one appointment in 14 days. In case of any issue please contact provider office.") {
                this.translateService.get('Appointment.appointment_14_day_check').subscribe((translation: string) => {
                  let text = translation;
                  this._phrutilService.showInfo(text);
                });
              }
              else {
                this._phrutilService.showInfo(res.data.finalMessage);
              }
              //this._phrutilService.showInfo(res.data.finalMessage);
            }
          } else {
            let text = "Service is not available, please try later.";
            this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showError(text);
            //this._phrutilService.showError("Service is not available, please try later.");
          }
        },
          (error: any) => {
            this.spinner.hide(); let text = "Service is not available, please try later.";
            this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showError(text);
            //this._phrutilService.showError("Service is not available, please try later.");
          });
      }
    }
    else {
      if (!this.loginForm.invalid && this.availableSlot != null && this.availableDate != null) {
        let text = "Please select appointment slot first.";
        this.translateService.get('Alerts.select_slot_first').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        //this._phrutilService.showInfo("Please select appointment slot first.");
      }
      return;
    }
  }
  validateEmailAddress(event: any) {
    if (event.value.length > 0) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.value)) {
        this.isValidEmail = true;
      }
      else {
        this.isValidEmail = false;
      }
    }
    else {
      this.isValidEmail = true;
    }
  }
  validatePhoneNo(field: any) {
    let phoneNumDigits = field.value.replace(/\D/g, '');
    field.value = phoneNumDigits;
    let isValidPhone = (phoneNumDigits.length == 0 || phoneNumDigits.length == 10);
    if (isValidPhone) {
      field.value = this._phrutilService.maskingPhoneNumer(phoneNumDigits);
    } else {
      field.value = phoneNumDigits;
    }
  }
  validatePhone(phoneNumDigits: any, type: any) {
    let dummyPhone = phoneNumDigits.replace(/\D/g, '');
    phoneNumDigits = dummyPhone.replace(/\s/g, '');
    if (type == "phone") {
      if (phoneNumDigits.length == 0 || phoneNumDigits.length == 14 || phoneNumDigits.length == 10) {
        this.isNotValidPhone = false;
        if (phoneNumDigits.length != 0) {
          this.isShowVerifyButton = true;
          this.isNotCellPhone = false;
        }
      }
      else {
        this.isNotValidPhone = true;
        this.isShowVerifyButton = false;
      }
    }
  }
  handleNextClick() {
    if (this.isDrsite || this.isDrsiteCheckoutNotes || this.flowType === 'laborder') {
      this.LoginPatient();
    } else if (this.flowType === 'payment') {
      //if (this.isScanLicense && !this.isDob) {
      //  if (this.fileObjFront) {
      //    this.OCRDrivingLicenseService();
      //  } else {
      //    $("#cardMissing-model").modal("show");
      //  }
      //  return;
      //} else {
      //  this._phrutilService.setChekcinType("dob");
      //  this.LoginPatient();
      //}
      this._phrutilService.setChekcinType("dob");
      this.LoginPatient();
    } else {
      this.RegistorPatient();
    }
  }
  GetPatientDetailsByLabID() {
    const labId = localStorage.getItem('labid');
    if (labId != undefined && labId != null) {
      //this.spinner.show();
      this._login.GetPatientDetailsByLabID(this.patientpersonalinfo.practice_code, labId).subscribe((res: any) => {
        this.spinner.hide();
        if (res.statusCode == 200) {
          //console.log("res.data", res.data);
          this.first_name = res.data.first_Name ? this._phrutilService.decryptforServices(res.data.first_Name) : res.data.first_Name;
          //console.log("first_name", this.first_name);
          this.last_Name = res.data.last_Name ? this._phrutilService.decryptforServices(res.data.last_Name) : res.data.last_Name;
          const dob = res.data.date_Of_Birth ? this._phrutilService.decryptforServices(res.data.date_Of_Birth) : res.data.date_Of_Birth;
          //console.log("last_Name", this.last_Name);
          //console.log("date of birth", dob);
          //this.LoginPatient();
        } else if (res.statusCode == 404) {
          console.log("not found");
        }
      },
        (error: any) => {
         // this.spinner.hide();
         // let text = "Service is not available, please try later.";
         // this._phrutilService.showError(text);
        });

    }
    else {

    }
  }
  LoginPatient() {
    if (this.loginForm.valid) {
      const dobDay = this.loginForm.controls['dobDay'].value;
      const dobMonth = this.loginForm.controls['dobMonth'].value;
      const dobYear = this.loginForm.controls['dobyear'].value;
      this.date_of_birth = dobMonth + "/" + dobDay + "/" + dobYear;
      this.loginForm.markAllAsTouched();
      //console.log('Inside LoginPatient');
      if (!this.loginForm.invalid) {
        this.spinner.show();
        this._login.VerifyExistingPatientByNameDob(this.first_name, this.last_Name, this.date_of_birth, this.patientpersonalinfo.practice_code).subscribe((res: any) => {
          this.spinner.hide();
          if (res.statusCode == 200 && res.data.status.toLowerCase() == 'success') {
            this.loginResp = res.data;
            this.patientpersonalinfo.date_Of_Birth = this.loginResp.date_Of_Birth;
            this.patientpersonalinfo.email_Address = this.loginResp.email_Address;
            this.patientpersonalinfo.cell_phone = this.loginResp.cell_phone;
            this.patientpersonalinfo.first_Name = this.loginResp.first_Name;
            this.patientpersonalinfo.last_Name = this.loginResp.last_Name;
            this.patientpersonalinfo.practice_Code = this.loginResp.practice_Code;
            this.patientpersonalinfo.prac_Name = this.loginResp.prac_Name;
            this.patientpersonalinfo.patient_Account = this.loginResp.patient_Account;
            this.patientpersonalinfo.prac_Phone = this.loginResp.prac_Phone;
            this.patientpersonalinfo.gender = this.loginResp.gender;
            // console.log(this.patientpersonalinfo,"patientpersonalinfo");
            let data = this._phrutilService.encrypt(this.patientpersonalinfo);
            localStorage.setItem("AuthTokenwebServices", this.loginResp.accessTokenResponse.accessToken);
            localStorage.setItem("RefreashTokenwebServices", this.loginResp.accessTokenResponse.refreshToken);
            localStorage.setItem('PatientInfo', data);
            if (this.patientpersonalinfo.type == 'walkin') {
              //this._router.navigateByUrl("/exitingappointment")
              this.onAddScheduleAppointment()
            }
            else if (this.patientpersonalinfo.type == 'check-in') {
              this.getCheckinDetails(this.patientpersonalinfo.practice_Code, this.patientpersonalinfo.patient_Account);
            }

            else if (this.patientpersonalinfo.type == 'payment') {
              this.getPaymentDetails();
            }

            else if (this.patientpersonalinfo.type == 'laborder') {
              // const labId = localStorage.getItem('labid');
              // if (labId != undefined && labId != null) {
              //   this.getLabOrderDetails(labId);
              // }
              this._router.navigateByUrl('/plab');
            }

          }
          else if (res.data.status.toLowerCase() == 'no record found') {
            $("#isNotValid_linkexiting").modal("show");
            return;
          }
          else if (res.data.status.toLowerCase() == 'more then one patient exit with these info') {
            $("#ismorethenonepatient").modal("show");
            return;
          }
        }, (error: any) => {
          $("#isNotValid_linkexiting").modal("show");
          this.spinner.hide();
          return;
        });
      }
      else {
        return;
      }
    } else {
      this.loginForm.markAllAsTouched();
    }

  }
  getPatientData(pracCode: any, first_name: any, last_name: any, dob: any, From:any) {
    //console.log("getPatientData called with", pracCode, first_name, last_name, dob);
    this.spinner.show();
    this._VerifypatientService.VerifyExistingPatientByDob(pracCode, first_name, last_name, dob).subscribe((res: any) => {
      this.spinner.hide();
      //console.log("response in VerifyExistingPatientByDob", res);
      if (res.data) {
        if (res.data.status == 'success') {
          this._phrutilService.setChekcinType("dob");
          localStorage.setItem("AuthTokenwebServices", res.data.accessTokenResponse.accessToken);
          sessionStorage.setItem("AuthTokenwebServices", res.data.accessTokenResponse.accessToken);
          localStorage.setItem("RefreashTokenwebServices", res.data.accessTokenResponse.refreshToken);
          localStorage.setItem('pictureAddress', res.data.picture_Address);
          //console.log("verii " + res.data.accessTokenResponse.accessToken);
          //console.log("verii loc GetData" + localStorage.getItem("AuthTokenwebServices"));
          //console.log(res.data);
          this.getPatientInfo.emailAddress = res.data.emailAddress ? this._phrutilService.decryptforServices(res.data.emailAddress) : res.data.emailAddress;
          this.getPatientInfo.visitDate = res.data.visitDate;
          localStorage.setItem('visitDate', this.getPatientInfo.visitDate);
          this.getPatientInfo.timE_FROM = res.data.timE_FROM;
          this.getPatientInfo.visitReason = res.data.visitReason;
          this.getPatientInfo.dateOfBirth = res.data.dateOfBirth ? this._phrutilService.decryptforServices(res.data.dateOfBirth) : res.data.dateOfBirth;
          this.getPatientInfo.cellPhone = res.data.cellPhone ? this._phrutilService.decryptforServices(res.data.cellPhone) : res.data.cellPhone;
          this.getPatientInfo.firstName = res.data.firstName ? this._phrutilService.decryptforServices(res.data.firstName) : res.data.firstName;
          this.getPatientInfo.lastName = res.data.lastName ? this._phrutilService.decryptforServices(res.data.lastName) : res.data.lastName;
          this.getPatientInfo.practiceCode = res.data.practiceCode ? this._phrutilService.decryptforServices(res.data.practiceCode) : res.data.practiceCode;
          this.getPatientInfo.todaY_AMMOUNT = res.data.todaY_AMMOUNT;
          this.getPatientInfo.previouS_AMMOUNT = res.data.previouS_AMMOUNT;
          this.getPatientInfo.providerLastName = res.data.providerLastName ? this._phrutilService.decryptforServices(res.data.providerLastName) : res.data.providerLastName;
          this.getPatientInfo.providerFirstName = res.data.providerFirstName ? this._phrutilService.decryptforServices(res.data.providerFirstName) : res.data.providerFirstName;
          this.getPatientInfo.providerCode = res.data.providerCode ? this._phrutilService.decryptforServices(res.data.providerCode) : res.data.providerCode;
          this.getPatientInfo.practiceName = res.data.practiceName ? this._phrutilService.decryptforServices(res.data.practiceName) : res.data.practiceName;
          this.getPatientInfo.patientAccount = res.data.patientAccount ? this._phrutilService.decryptforServices(res.data.patientAccount) : res.data.patientAccount;
          this.getPatientInfo.appointment_id = res.data.appointment_id ? this._phrutilService.decryptforServices(res.data.appointment_id) : res.data.appointment_id;
          this.getPatientInfo.practicePhone = res.data.practicePhone ? this._phrutilService.decryptforServices(res.data.practicePhone) : res.data.practicePhone;
          this.getPatientInfo.picture_Address = res.data.picture_Address ? this._phrutilService.decryptforServices(res.data.picture_Address) : res.data.picture_Address;
          this.getPatientInfo.languages = res.data.languages ? this._phrutilService.decryptforServices(res.data.languages) : res.data.languages;
          this.getPatientInfo.practiceAddress = res.data.practiceAddress ? this._phrutilService.decryptforServices(res.data.practiceAddress) : res.data.practiceAddress;
          this.getPatientInfo.PracticeCity = res.data.practiceCity ? this._phrutilService.decryptforServices(res.data.practiceCity) : res.data.practiceCity;
          this.getPatientInfo.practiceState = res.data.practiceState ? this._phrutilService.decryptforServices(res.data.practiceState) : res.data.practiceState;
          this.getPatientInfo.praticeZip = res.data.praticeZip ? this._phrutilService.decryptforServices(res.data.praticeZip) : res.data.praticeZip;
          this.getPatientInfo.praticeZip = this._phrutilService.maskingZipNum(this.getPatientInfo.praticeZip);
          this.getPatientInfo.reason_Id = res.data.reason_Id ? this._phrutilService.decryptforServices(res.data.reason_Id) : res.data.reason_Id;
          this.getPatientInfo.reasonName = res.data.reasonName ? this._phrutilService.decryptforServices(res.data.reasonName) : res.data.reasonName;
          this.getPatientInfo.appointmentStatusId = res.data.appointmentStatusId ? this._phrutilService.decryptforServices(res.data.appointmentStatusId) : res.data.appointmentStatusId;
          this.getPatientInfo.appointment_End_DateTime = res.data.appointment_End_DateTime ? this._phrutilService.decryptforServices(res.data.appointment_End_DateTime) : res.data.appointment_End_DateTime;
          this.getPatientInfo.appointmentDuration = res.data.appointmentDuration ? this._phrutilService.decryptforServices(res.data.appointmentDuration) : res.data.appointmentDuration;
          this.getPatientInfo.appointmentAddress = res.data.appointmentAddress ? this._phrutilService.decryptforServices(res.data.appointmentAddress) : res.data.appointmentAddress;
          this.getPatientInfo.appointmentState = res.data.appointmentState ? this._phrutilService.decryptforServices(res.data.appointmentState) : res.data.appointmentState;
          this.getPatientInfo.appointmentCity = res.data.appointmentCity ? this._phrutilService.decryptforServices(res.data.appointmentCity) : res.data.appointmentCity;
          this.getPatientInfo.appointmentZip = res.data.appointmentZip ? this._phrutilService.decryptforServices(res.data.appointmentZip) : res.data.appointmentZip;
          this.getPatientInfo.appointmentZip = this._phrutilService.maskingZipNum(this.getPatientInfo.appointmentZip);
          this.getPatientInfo.isBreezePaymentEnabled = res.data.isBreezePaymentEnabled;
          this.getPatientInfo.isPayLaterEnabled = res.data.isPayLaterEnabled;
          let data = this._phrutilService.encrypt(this.getPatientInfo);
          //console.log('getPatientInfo', this._phrutilService.decrypt(data));
          localStorage.setItem('PatientInfoCheckin', data);
          //localStorage.setItem('PatientInfo', data);
          //console.log('PatientInfoCheckin', this._phrutilService.encrypt(localStorage.getItem('PatientInfo')));
          const landfrom = localStorage.getItem("landFrom");
          if (landfrom != undefined && landfrom != null) {
            this.trackPatientPreference(landfrom);
          }
          //console.log("ispaylater enabled ", this.getPatientInfo.isPayLaterEnabled);
          //console.log("appt status id ", this.getPatientInfo.appointmentStatusId);
          //console.log("appt start time ", this.getPatientInfo.timE_FROM);
          //console.log("appt end time ", this.getPatientInfo.appointment_End_DateTime);
          //console.log("isBreezePaymentEnabled ", this.getPatientInfo.isBreezePaymentEnabled);
          localStorage.setItem("apptEndTime", this.getPatientInfo.appointment_End_DateTime);
          localStorage.setItem("apptStartTime", this.getPatientInfo.visitDate);
          localStorage.setItem("pcode", this.getPatientInfo.practiceCode);
          localStorage.setItem("reason", this.getPatientInfo.reasonName);
          localStorage.setItem("state", this.getPatientInfo.practiceState);
          localStorage.setItem("city", this.getPatientInfo.PracticeCity);
          localStorage.setItem("zip", this.getPatientInfo.praticeZip);
          localStorage.setItem("Pcell", this.getPatientInfo.practicePhone);
          localStorage.setItem("Padder", this.getPatientInfo.practiceAddress);
          localStorage.setItem("prcode", this.getPatientInfo.providerCode);
          localStorage.setItem("apptId", this.getPatientInfo.appointment_id);
          localStorage.setItem("apptstId", this.getPatientInfo.appointmentStatusId);
          localStorage.setItem("ptcode", this.getPatientInfo.patientAccount);
          localStorage.setItem("fname", this.getPatientInfo.firstName);
          localStorage.setItem("lname", this.getPatientInfo.lastName);
          localStorage.setItem("isBreezePaymentEnabled", this.getPatientInfo.isBreezePaymentEnabled);
          localStorage.setItem("isPayLaterEnabled", this.getPatientInfo.isPayLaterEnabled);
          //console.log("patient account ", this.getPatientInfo.patientAccount);
          this.patientpersonalinfo.patient_Account = this.getPatientInfo.patientAccount;
          this.isWithin3Hours = this.checkinBeforeThreeHours(this.getPatientInfo.visitDate, this.getPatientInfo.timE_FROM);
          localStorage.setItem('isWithin3Hours', this.isWithin3Hours);
          //console.log("is with in 3 hours " + this.isWithin3Hours)
          this.verifyPatientfromDS(dob)
          if ((this.getPatientInfo.practiceCode == '1011163' || this.getPatientInfo.practiceCode == '100') && this.getPatientInfo.reasonName == 'Initial Visit') {
            this.isWithin24Hours = this.checkIfVisitWithin24Hours(this.getPatientInfo.visitDate, this.getPatientInfo.timE_FROM);
            //console.log("is Same date " + this.isWithin24Hours); // Output: true or false
            localStorage.setItem('isWithin24Hours', this.isWithin24Hours);
          }
          this._phrutilService.setNavbarLastName(this.getPatientInfo.lastName);
          this._phrutilService.setNavpracName(this.getPatientInfo.practiceName);
          //console.log("getPatientData landfrom", landfrom);
          if (landfrom == undefined && landfrom == null || landfrom == 'qrcode') {
            //console.log("navigating to appoin-mes");
            this._router.navigateByUrl("/appoin-mes");
          }
          else {
            localStorage.setItem('PatientInfo', data);
            this._router.navigateByUrl('/pay_type');
          }
        }
        else {
          if (From == "scan") {
            this.isDobChecked = true;
            $("#incorrectinfoLicense-model").modal("show");
            localStorage.removeItem('licensedata');
          } else {
            $("#isNotValid_linkexiting").modal("show");
            localStorage.removeItem('licensedata');
          }
          return;
        }

      }
      else if (res.message.toLowerCase() == 'no record found') {
        if (From == "scan") {
          this.isDobChecked = true;
          $("#incorrectinfoLicense-model").modal("show");
        } else {
          $("#isNotValid_linkexiting").modal("show");
        }
        return;
      }
      else if (res.message.toLowerCase() == 'more than one patient exists with same dob.' || res.message.toLowerCase() == 'more than one first name exists.' || res.message.toLowerCase() == 'more than one patient exists with same last name.') {
        return;
      }
      else {
        $("#linkexpire-model").modal("show");
        return;
      }
    }, (error: any) => {
      this.spinner.hide();
      $("#linkexpire-model").modal("show");
      return;
    });
  }

  getPatientDataByEmailCell(pracCode: any, cellno: any, email: any, dob: any, From: any) {
    //console.log("getPatientData called with", pracCode, first_name, last_name, dob);
    this.spinner.show();
    this._VerifypatientService.VerifyExistingPatientByCellEmail(pracCode, cellno, email, dob).subscribe((res: any) => {
      this.spinner.hide();
      //console.log("response in VerifyExistingPatientByCellEmail", res);
      if (res.data) {
        if (res.data.status == 'success') {
          this._phrutilService.setChekcinType("dob");
          localStorage.setItem("AuthTokenwebServices", res.data.accessTokenResponse.accessToken);
          sessionStorage.setItem("AuthTokenwebServices", res.data.accessTokenResponse.accessToken);
          localStorage.setItem("RefreashTokenwebServices", res.data.accessTokenResponse.refreshToken);
          localStorage.setItem('pictureAddress', res.data.picture_Address);
          //console.log("verii " + res.data.accessTokenResponse.accessToken);
          //console.log("verii loc GetData" + localStorage.getItem("AuthTokenwebServices"));
          //console.log(res.data);
          this.getPatientInfo.emailAddress = res.data.emailAddress ? this._phrutilService.decryptforServices(res.data.emailAddress) : res.data.emailAddress;
          this.getPatientInfo.visitDate = res.data.visitDate;
          localStorage.setItem('visitDate', this.getPatientInfo.visitDate);
          this.getPatientInfo.timE_FROM = res.data.timE_FROM;
          this.getPatientInfo.visitReason = res.data.visitReason;
          this.getPatientInfo.dateOfBirth = res.data.dateOfBirth ? this._phrutilService.decryptforServices(res.data.dateOfBirth) : res.data.dateOfBirth;
          this.getPatientInfo.cellPhone = res.data.cellPhone ? this._phrutilService.decryptforServices(res.data.cellPhone) : res.data.cellPhone;
          this.getPatientInfo.firstName = res.data.firstName ? this._phrutilService.decryptforServices(res.data.firstName) : res.data.firstName;
          this.getPatientInfo.lastName = res.data.lastName ? this._phrutilService.decryptforServices(res.data.lastName) : res.data.lastName;
          this.getPatientInfo.practiceCode = res.data.practiceCode ? this._phrutilService.decryptforServices(res.data.practiceCode) : res.data.practiceCode;
          this.getPatientInfo.todaY_AMMOUNT = res.data.todaY_AMMOUNT;
          this.getPatientInfo.previouS_AMMOUNT = res.data.previouS_AMMOUNT;
          this.getPatientInfo.providerLastName = res.data.providerLastName ? this._phrutilService.decryptforServices(res.data.providerLastName) : res.data.providerLastName;
          this.getPatientInfo.providerFirstName = res.data.providerFirstName ? this._phrutilService.decryptforServices(res.data.providerFirstName) : res.data.providerFirstName;
          this.getPatientInfo.providerCode = res.data.providerCode ? this._phrutilService.decryptforServices(res.data.providerCode) : res.data.providerCode;
          this.getPatientInfo.practiceName = res.data.practiceName ? this._phrutilService.decryptforServices(res.data.practiceName) : res.data.practiceName;
          this.getPatientInfo.patientAccount = res.data.patientAccount ? this._phrutilService.decryptforServices(res.data.patientAccount) : res.data.patientAccount;
          this.getPatientInfo.appointment_id = res.data.appointment_id ? this._phrutilService.decryptforServices(res.data.appointment_id) : res.data.appointment_id;
          this.getPatientInfo.practicePhone = res.data.practicePhone ? this._phrutilService.decryptforServices(res.data.practicePhone) : res.data.practicePhone;
          this.getPatientInfo.picture_Address = res.data.picture_Address ? this._phrutilService.decryptforServices(res.data.picture_Address) : res.data.picture_Address;
          this.getPatientInfo.languages = res.data.languages ? this._phrutilService.decryptforServices(res.data.languages) : res.data.languages;
          this.getPatientInfo.practiceAddress = res.data.practiceAddress ? this._phrutilService.decryptforServices(res.data.practiceAddress) : res.data.practiceAddress;
          this.getPatientInfo.PracticeCity = res.data.practiceCity ? this._phrutilService.decryptforServices(res.data.practiceCity) : res.data.practiceCity;
          this.getPatientInfo.practiceState = res.data.practiceState ? this._phrutilService.decryptforServices(res.data.practiceState) : res.data.practiceState;
          this.getPatientInfo.praticeZip = res.data.praticeZip ? this._phrutilService.decryptforServices(res.data.praticeZip) : res.data.praticeZip;
          this.getPatientInfo.praticeZip = this._phrutilService.maskingZipNum(this.getPatientInfo.praticeZip);
          this.getPatientInfo.reason_Id = res.data.reason_Id ? this._phrutilService.decryptforServices(res.data.reason_Id) : res.data.reason_Id;
          this.getPatientInfo.reasonName = res.data.reasonName ? this._phrutilService.decryptforServices(res.data.reasonName) : res.data.reasonName;
          this.getPatientInfo.appointmentStatusId = res.data.appointmentStatusId ? this._phrutilService.decryptforServices(res.data.appointmentStatusId) : res.data.appointmentStatusId;
          this.getPatientInfo.appointment_End_DateTime = res.data.appointment_End_DateTime ? this._phrutilService.decryptforServices(res.data.appointment_End_DateTime) : res.data.appointment_End_DateTime;
          this.getPatientInfo.appointmentDuration = res.data.appointmentDuration ? this._phrutilService.decryptforServices(res.data.appointmentDuration) : res.data.appointmentDuration;
          this.getPatientInfo.appointmentAddress = res.data.appointmentAddress ? this._phrutilService.decryptforServices(res.data.appointmentAddress) : res.data.appointmentAddress;
          this.getPatientInfo.appointmentState = res.data.appointmentState ? this._phrutilService.decryptforServices(res.data.appointmentState) : res.data.appointmentState;
          this.getPatientInfo.appointmentCity = res.data.appointmentCity ? this._phrutilService.decryptforServices(res.data.appointmentCity) : res.data.appointmentCity;
          this.getPatientInfo.appointmentZip = res.data.appointmentZip ? this._phrutilService.decryptforServices(res.data.appointmentZip) : res.data.appointmentZip;
          this.getPatientInfo.appointmentZip = this._phrutilService.maskingZipNum(this.getPatientInfo.appointmentZip);
          this.getPatientInfo.isBreezePaymentEnabled = res.data.isBreezePaymentEnabled;
          this.getPatientInfo.isPayLaterEnabled = res.data.isPayLaterEnabled;
          let data = this._phrutilService.encrypt(this.getPatientInfo);
          //console.log('getPatientInfo', this._phrutilService.decrypt(data));
          localStorage.setItem('PatientInfoCheckin', data);
          //localStorage.setItem('PatientInfo', data);
          //console.log('PatientInfoCheckin', this._phrutilService.encrypt(localStorage.getItem('PatientInfo')));
          const landfrom = localStorage.getItem("landFrom");
          if (landfrom != undefined && landfrom != null) {
            this.trackPatientPreference(landfrom);
          }
          //console.log("ispaylater enabled ", this.getPatientInfo.isPayLaterEnabled);
          //console.log("appt status id ", this.getPatientInfo.appointmentStatusId);
          //console.log("appt start time ", this.getPatientInfo.timE_FROM);
          //console.log("appt end time ", this.getPatientInfo.appointment_End_DateTime);
          //console.log("isBreezePaymentEnabled ", this.getPatientInfo.isBreezePaymentEnabled);
          localStorage.setItem("apptEndTime", this.getPatientInfo.appointment_End_DateTime);
          localStorage.setItem("apptStartTime", this.getPatientInfo.visitDate);
          localStorage.setItem("pcode", this.getPatientInfo.practiceCode);
          localStorage.setItem("reason", this.getPatientInfo.reasonName);
          localStorage.setItem("state", this.getPatientInfo.practiceState);
          localStorage.setItem("city", this.getPatientInfo.PracticeCity);
          localStorage.setItem("zip", this.getPatientInfo.praticeZip);
          localStorage.setItem("Pcell", this.getPatientInfo.practicePhone);
          localStorage.setItem("Padder", this.getPatientInfo.practiceAddress);
          localStorage.setItem("prcode", this.getPatientInfo.providerCode);
          localStorage.setItem("apptId", this.getPatientInfo.appointment_id);
          localStorage.setItem("apptstId", this.getPatientInfo.appointmentStatusId);
          localStorage.setItem("ptcode", this.getPatientInfo.patientAccount);
          localStorage.setItem("fname", this.getPatientInfo.firstName);
          localStorage.setItem("lname", this.getPatientInfo.lastName);
          localStorage.setItem("isBreezePaymentEnabled", this.getPatientInfo.isBreezePaymentEnabled);
          localStorage.setItem("isPayLaterEnabled", this.getPatientInfo.isPayLaterEnabled);
          //console.log("patient account ", this.getPatientInfo.patientAccount);
          this.patientpersonalinfo.patient_Account = this.getPatientInfo.patientAccount;
          this.isWithin3Hours = this.checkinBeforeThreeHours(this.getPatientInfo.visitDate, this.getPatientInfo.timE_FROM);
          localStorage.setItem('isWithin3Hours', this.isWithin3Hours);
          //console.log("is with in 3 hours " + this.isWithin3Hours)
          this.verifyPatientfromDS(dob)
          if ((this.getPatientInfo.practiceCode == '1011163' || this.getPatientInfo.practiceCode == '100') && this.getPatientInfo.reasonName == 'Initial Visit') {
            this.isWithin24Hours = this.checkIfVisitWithin24Hours(this.getPatientInfo.visitDate, this.getPatientInfo.timE_FROM);
            //console.log("is Same date " + this.isWithin24Hours); // Output: true or false
            localStorage.setItem('isWithin24Hours', this.isWithin24Hours);
          }
          this._phrutilService.setNavbarLastName(this.getPatientInfo.lastName);
          this._phrutilService.setNavpracName(this.getPatientInfo.practiceName);
          //console.log("getPatientData landfrom", landfrom);
          if (landfrom == undefined && landfrom == null || landfrom == 'qrcode') {
            //console.log("navigating to appoin-mes");
            this._router.navigateByUrl("/appoin-mes");
          }
          else {
            localStorage.setItem('PatientInfo', data);
            this._router.navigateByUrl('/pay_type');
          }
        }
        else {
          if (From == "scan") {
            this.isDobChecked = true;
            $("#incorrectinfoLicense-model").modal("show");
            localStorage.removeItem('licensedata');
          } else {
            $("#isNotValid_linkexiting").modal("show");
            localStorage.removeItem('licensedata');
          }
          return;
        }

      }
      else if (res.message.toLowerCase() == 'no record found') {
        if (From == "scan") {
          this.isDobChecked = true;
          $("#incorrectinfoLicense-model").modal("show");
        } else {
          $("#isNotValid_linkexiting").modal("show");
        }
        return;
      }
      else if (res.message.toLowerCase() == 'more than one patient exists with same dob.' || res.message.toLowerCase() == 'more than one first name exists.' || res.message.toLowerCase() == 'more than one patient exists with same last name.') {
        return;
      }
      else {
        $("#linkexpire-model").modal("show");
        return;
      }
    }, (error: any) => {
      this.spinner.hide();
      $("#linkexpire-model").modal("show");
      return;
    });
  }

  onSubmit() {
    if (this.isScanLicense && !this.isDob) {
      if (this.fileObjFront) {
        this.OCRDrivingLicenseService();
      } else {
        $("#cardMissing-model").modal("show");
      }

      return;
    }
    this._phrutilService.setChekcinType("dob");
    if (this.loginForm.valid) {
      const dobDay = this.loginForm.controls['dobDay'].value;
      const dobMonth = this.loginForm.controls['dobMonth'].value;
      const dobYear = this.loginForm.controls['dobyear'].value;
      this.formattedDate = dobMonth + "/" + dobDay + "/" + dobYear;
      //console.log("formated date ", this.formattedDate);

      if (this.isCell) {
        if (!this.isNotValidPhone && this.isValidEmail) {
          const cellno = this.loginForm.controls['cellPhone'].value;
          const email = this.loginForm.controls['EmailAddress'].value;
          this.getPatientDataByEmailCell(this.patientpersonalinfo.practice_Code, cellno, email, this.formattedDate, "dob");
        }
      } else if (this.isName) {
        const firstname = this.loginForm.controls['firstname'].value;
        const lastname = this.loginForm.controls['lastname'].value;
        this.getPatientData(this.patientpersonalinfo.practice_Code, firstname, lastname, this.formattedDate, "dob");
      }

      //console.log("new API hit in onSubmit");
    

    } else {
      this.loginForm.markAllAsTouched();
    }

  }
  RegistorPatient() {
    if (this.loginForm.valid) {
      //console.log('PracticeCode:', this.patientpersonalinfo.practice_Code)
      //console.log('Invalid:', this.loginForm.invalid)
      //console.log('Email:', this.isValidEmail)
      const dobDay = this.loginForm.controls['dobDay'].value;
      const dobMonth = this.loginForm.controls['dobMonth'].value;
      const dobYear = this.loginForm.controls['dobyear'].value;
      this.formattedDate = dobMonth + "/" + dobDay + "/" + dobYear;
      console.log("formated date ", this.formattedDate);
      // if (!this.registrationForm.invalid && this.checkFieldValidaiton() && this.verifiedCellPhone && this.isValidEmail) {
      if (this.checkFieldValidaiton() && this.isValidEmail) {
        //console.log('InsideRegistorPatient:', this.patientpersonalinfo.practice_Code)
        this.spinner.show();
        this.registration.date_Of_Birth = this.formattedDate//this.datepipe.transform(new Date(this.loginForm.get('dob')!.value), 'MM/dd/yyyy');
        this.registration.practice_Code = this.patientpersonalinfo.practice_Code;
        this.registration.email_Address = this.loginForm.controls['email'].value;//this.loginForm.get('email')!.value;
        this.registration.location_Code = this.dropdownValues.location.id;
        this.registration.last_Name = this.loginForm.controls['lastname'].value;//this.loginForm.get('lastname')!.value;
        this.registration.first_Name = this.loginForm.controls['firstname'].value;//this.loginForm.get('firstname')!.value;
        this.registration.gender = '';//this.loginForm.get('gender')!.value;
        this.registration.cell_phone = this.loginForm.controls['cell']!.value.replace(/\D/g, '');//this.loginForm.get('cell')!.value.replace(/\D/g, '');
        this.registration.zip = '';
        this.registration.state = '';
        this.registration.city = '';
        this.registration.address = '';
        this.registration.created_By = 'Breeze check-in'
        this.registration.modified_By = '';
        this._registor.RegistorPatient(this.registration).subscribe((res: any) => {
          this.spinner.hide();
          // if (res.statusCode == 200) {
          //   this.verifyPatientfromDS(this.formattedDate)
          // }
          if (res.statusCode == 200 && res.message == "Patient registerd successfuly") {
            this.RegistrationResponce = res.data;
            this.RegistrationResponce.PracticeName = this.practice_name;
            let data = this._phrutilService.encrypt(this.RegistrationResponce);
            localStorage.setItem('PatientInfo', data);
            this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PatientInfo'));
            //console.log("patientpersonalinfo", this.patientpersonalinfo)
            localStorage.setItem("AuthTokenwebServices", res.data.accessTokenResponse.accessToken);
            localStorage.setItem("RefreashTokenwebServices", res.data.accessTokenResponse.refreshToken);
            let text;
            this.translateService.get('RegistrationPage.registrationAlerts.patient_Register_successfully').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showSuccess(text);
            //this._phrutilService.showSuccess("Patient Register successfully");
            if (this.practice_code != '1013675') {
              //this._router.navigateByUrl('/appointment');
              this.onAddScheduleAppointment()
            } else {
              //this._router.navigateByUrl('/pay_type');
              this._router.navigateByUrl('/registration-consent-form');
            }

          }
          else if (res.message && res.message.toLowerCase() === "patient already exists") {
            this.RegistrationResponce = res.data;
            this.RegistrationResponce.PracticeName = this.practice_name;
            let data = this._phrutilService.encrypt(this.RegistrationResponce);
            localStorage.setItem('PatientInfo', data);
            this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PatientInfo'));
            //console.log("patientpersonalinfo", this.patientpersonalinfo)
            localStorage.setItem("AuthTokenwebServices", res.data.accessTokenResponse.accessToken);
            localStorage.setItem("RefreashTokenwebServices", res.data.accessTokenResponse.refreshToken);
            this.onAddScheduleAppointment();
          }
          else {
            let text = "Service is not available, please try later.";
            this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showError(text);
            //this._phrutilService.showError("Service is not available, please try later.");
          }
        }, (error: any) => {
          this.spinner.hide();

        });
      }
      else {//OTP removed as per Sir Adeel serwer
        //if(!this.verifiedCellPhone && this.checkFieldValidaiton() && this.registrationForm.valid)
        //{
        //  this._phrutilService.showInfo("Please verify your Cell phone");
        //}
      }
    }
    else {
      this.loginForm.markAllAsTouched();
    }
  }
  checkFieldValidaiton() {
    //console.log('InsideValidation')
    if (this.loginForm.get('dob')) {
      const dobControl = this.loginForm.get('dob') as FormControl;
      if (dobControl.value) {
        if ((new Date(this.maxDate)) < (new Date(dobControl.value))) {
          let text;
          this.translateService.get('RegistrationPage.registrationAlerts.fture_date_of_birth_is_not_allowed').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showInfo(text);
          return;
        }
      }
    }
    if (!this.loginForm.get('cell')!.value || this.loginForm.get('cell')!.value.length == 0) {
      this.isNotCellPhone = true;
      return false;
    }
    else {
      //console.log('isNotCellPhone')
      this.isNotCellPhone = false;
      return true;
    }
  }
  @ViewChild(NgOtpInputComponent, { static: false })
  ngOtpInput: NgOtpInputComponent;
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  config: NgOtpInputConfig = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: true,
    placeholder: '',
    letterCase: 'Upper',

  };
  SendOTP() {
    if (!this.loginResp) {
      return;
    }
    this.phoneLink = '';
    this.linkType = '';
    let obj = {
      "applicationName": "BreezeCheckin",
      "userName": this.loginResp.cell_phone || this.loginResp.email_Address,
      "deviceInfo": "web",
      "appDisplayName": "Breeze Checkin"
    };

    this.phoneLink = this.loginResp.cell_phone || this.loginResp.email_Address;
    if (this.loginResp.cell_phone) {
      this.linkType = 'phone number';
      this.phoneLink = '*** *** **' + this.phoneLink.substring(this.phoneLink.length - 4, this.phoneLink.length);
    }
    else {
      let emailClient = this.phoneLink.split('@');
      this.linkType = 'email';
      this.phoneLink = this.phoneLink.substring(0, 1) + '*****@' + emailClient[1];
    }

    this.spinner.show();
    this.isSendingOTP = true;
    this._login.SendOTP(obj).subscribe((res: any) => {
      this.isSendingOTP = false;
      this.remainingTime = 1;
      this.spinner.hide();
      $('#verifycode').modal('show');
      $('.ng-otp-input-wrapper').removeClass('wrapper');
      this.otpResp = res;
      if (res.status == true && res.message == 'OTP Sent') {
        this.OTPTimer(179);
        this.ngOtpInput.setValue('');
      }
      else {
        this._phrutilService.showError(res.message);
      }
    }, (error: any) => {
      this.isSendingOTP = false;
      this._phrutilService.showError(error.toString());
      this.spinner.hide();
    });
  }
  verifyOTP() {
    if (this.otpResp == null) {
      return;
    }
    if (Number(this.s) == 0 && Number(this.m) == 0) {
      let text = "Code expired. Tap resend code and try again.";
      this.translateService.get('Alerts.code_expired').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
      // this._phrutilService.showError("Code expired. Tap resend code and try again.");
      return;
    }

    if (this.otp && this.otp.length == 4) {
      this.otpEntered = true;
      let obj = {
        "deviceInfo": "web",
        "notifier": this.otpResp.data,
        "otp": this.otp
      };
      this.spinner.show();
      this.isVerifying = true;
      this._login.VerifyOTP(obj).subscribe((res: any) => {
        this.isVerifying = false;
        this.spinner.hide();
        this.verResp = res;
        if (res.status == true && res.message.toLowerCase() == "otp verified successfully") {
          $('#verifycode').modal('hide');
          this.patientpersonalinfo.date_Of_Birth = this.loginResp.date_Of_Birth;
          this.patientpersonalinfo.email_Address = this.loginResp.email_Address;
          this.patientpersonalinfo.cell_phone = this.loginResp.cell_phone;
          this.patientpersonalinfo.first_Name = this.loginResp.first_Name;
          this.patientpersonalinfo.last_Name = this.loginResp.last_Name;
          this.patientpersonalinfo.practice_Code = this.loginResp.practice_Code;
          this.patientpersonalinfo.prac_Name = this.loginResp.prac_Name;
          this.patientpersonalinfo.patient_Account = this.loginResp.patient_Account;
          this.patientpersonalinfo.prac_Phone = this.loginResp.prac_Phone;
          this.patientpersonalinfo.gender = this.loginResp.gender;
          let data = this._phrutilService.encrypt(this.patientpersonalinfo);
          localStorage.setItem("AuthTokenwebServices", this.loginResp.accessTokenResponse.accessToken);
          localStorage.setItem("RefreashTokenwebServices", this.loginResp.accessTokenResponse.refreshToken);
          localStorage.setItem('PatientInfo', data);
          if (this.patientpersonalinfo.type == 'walkin') {
            this._router.navigateByUrl("/exitingappointment");
          }
          else if (this.patientpersonalinfo.type == 'check-in') {
            localStorage.setItem("landFrom", "check-in");
            this.getCheckinDetails(this.patientpersonalinfo.practice_Code, this.patientpersonalinfo.patient_Account);
          }
          else if (this.patientpersonalinfo.type == 'payment') {
            this._router.navigateByUrl("/payment-overview");
          }
        }
        else if (res.message.toLowerCase().includes('failed')) {
          let text = "Invalid OTP Code. Try again.";
          this.translateService.get('Alerts.invalid_otp_code').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Invalid OTP Code. Try again.");
        }
      }, (error: any) => {
        this.isVerifying = false;
        this._phrutilService.showError(error.toString());
        this.spinner.hide();
      });
    }
    else {
      this.otpEntered = false;
    }
  }
  onOtpChange(otp: any) {
    if (this.isVerifying) {
      return;
    }
    if (otp.length == 4) {
      this.otp = otp;
      this.verifyOTP();
    }
    else {
      this.otp == '';
      this.isVerifying = false;
    }
  }
  OTPTimer(remaining: any) {
    this.m = Math.floor(remaining / 60).toString();
    this.s = (remaining % 60).toString();
    this.m = Number(this.m) < 10 ? '0' + this.m : this.m;
    this.s = Number(this.s) < 10 ? '0' + this.s : this.s;

    this.timer = setTimeout(() => {
      if (remaining >= 1) {
        this.remainingTime = remaining -= 1;
        this.OTPTimer(remaining);
        if (this.remainingTime == 0) {
          this.timer = 0;
          this.clearTimer();
        }
      }
      else {
        return;
      }
    }, 1000);
  }
  VerifyPractice(practice_code: any) {
    this.spinner.show();
    this._registor.VerifyPracticeCode(practice_code).subscribe((res: any) => {
      this.spinner.hide();
      if (res.data && res.statusCode == 200) {
        this.practice_code = res.data.practice_Code;
        this.practice_name = res.data.prac_Name;
        this._phrutilService.setNavpracName(this.practice_name);
        //this.getLocation(this.practice_code);
      }
      else {
        $("#isNotValid_link").modal("show");
        return;
      }
    },
      (error: any) => {
        this.spinner.hide();
        $("#isNotValid_link").modal("show");
      });
  }
  getCheckinDetails(practice_code: any, patient_account: any) {
    this.spinner.show();
    this._login.GetCheckinDetails(practice_code, patient_account).subscribe((res: any) => {
      this.spinner.hide();
      if (res.statusCode == 200 && res.data.status.toLowerCase() == 'success') {
        this.patientpersonalinfo.appointmentid = res.data.appointment_Id;
        this.patientpersonalinfo.reason_Id = res.data.reason_Id;
        this.patientpersonalinfo.reasonName = res.data.reasonName;
        this.patientpersonalinfo.appointment_Date_Time = res.data.appointment_Date_Time;
        this.patientpersonalinfo.location_Id = res.data.location_Id;
        this.patientpersonalinfo.time_form = res.data.time_From;
        this.patientpersonalinfo.provider_Code = res.data.provider_Code;
        this.patientpersonalinfo.teleMedicine_Session = res.data.teleMedicine_Session;
        let data = this._phrutilService.encrypt(this.patientpersonalinfo);
        localStorage.setItem('PatientInfo', data);
        localStorage.setItem('PersonalInfo', data);
        this._router.navigateByUrl("/appoin-mes");
      }
      else if (res.data.status.toLowerCase() == 'no appointment for today') {
        $("#noAppointmentFound").modal("show");
      }
      else if (res.data.status.toLowerCase() == 'already checked in') {
        $("#alreadycheckin").modal("show");
      }
      else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
      //this._phrutilService.showError("Service is not available, please try later.");
    });
  }
  //  backPage()
  //  {
  //    this.location.back();
  //    // this._router.navigateByUrl("/home?practice_code="+this.patientpersonalinfo.practice_Code);
  //}
  /*
  backPage() {
    this._route.queryParams.subscribe(params => {
      if (params['type'] === 'payment') {
        this._router.navigateByUrl("/home?practice_code=" + this.patientpersonalinfo.practice_code);
      } else {
        this.location.back();
      }
    });
  }*/
  backPage() {
    //console.log('back', this.location)
    //this.location.back();
    // this._router.navigateByUrl("/home?practice_code="+this.patientpersonalinfo.practice_Code);
    if (this.flowType === 'appointment') {

      const sanitizedSlot = this.availableSlot ? this.availableSlot.replace(/"/g, '').trim() : null;
      const queryParams = {
        showSlots: true,
        selectedSlot: sanitizedSlot,
        availableDate: this.availableDate,
        isFirstAvailable: this.isFirstAvailableDate,
        providerCode: this.providerCode
      };
      //console.log('Navigating with Query Params:', queryParams);

      // this._router.navigate(['/exitingappointment'], { queryParams: { showSlots: true, selectedSlot: this.availableSlot, availableDate: this.availableDate, isFirstAvailable: this.isFirstAvailableDate } });
      if (this.isDrsite) {
        this._router.navigate(['/scheduler'], { queryParams: { ...queryParams, lf: 'drsite' } });
      }
      else if (this.isDrsiteIntake) {
        this._router.navigate(['/scheduler'], { queryParams: { ...queryParams, lf: 'drsiteintake' } });
      }
      else if (this.isDrsiteCheckoutNotes) {
        this._router.navigate(['/scheduler'], { queryParams: { ...queryParams, lf: 'checkoutnotes', from: 'auth' } });
      }
      else
        this._router.navigate(['/exitingappointment'], { queryParams });
    }
    else {
      this._phrutilService.setChekcinType("dob");
      this.location.back();
    }
  }
  focusOutFunction(e: any, type: any) {
    // let date =  this.getloginForm.dob.value.split('-');
    // if(Number(date[0]) > this.curDate.getFullYear()){
    if ((new Date(this.maxDate)) < (new Date(this.loginForm.get('dob')!.value))) {
      this.getloginForm.dob.setErrors({ 'maxDate': true, 'invalid': true });
    }
  }
  clearTimer() {
    clearTimeout(this.timer);
    this.timer = 0;
  }
  ngOnDestroy(): void {
    clearTimeout(this.timer);
    this.timer = 0;
  }
  getTokenForDataScience() {
    try {
      if (localStorage.getItem('AuthToken')) return;
      this._genericService.getTokenForDataScience().subscribe({
        next: (res: any) => {
          try {
            if (res?.RESPONSE?.token) {
              localStorage.setItem('AuthToken', res.RESPONSE.token);
            }
          } catch (err) {
            console.error('Error storing AuthToken:', err);
          }
        },
        error: (err) => {
          console.error('Error fetching token for data science:', err);
        }
      });
    } catch (err) {
      console.error('Error in getTokenForDataScience:', err);
    }
  }
  verifyPatientfromDS(dob: any) {
    //console.log("apna dob... " + dob)
    // Ensure VerifypatientModule is initialized
    if (!this.VerifypatientModule) {
      this.VerifypatientModule = {
        DOB: '',
        PRACTICE_CODE: '',
        LAST_NAME: '',
        FIRST_NAME: '',
        APPOINTMENT_ID: ''
      };
    }
    this.spinner.show();
    this.VerifypatientModule.DOB = dob;
    this.VerifypatientModule.PRACTICE_CODE = this.getPatientInfo.practiceCode;
    this.VerifypatientModule.LAST_NAME = this.getPatientInfo.lastName;
    this.VerifypatientModule.FIRST_NAME = this.getPatientInfo.firstName;
    this.VerifypatientModule.APPOINTMENT_ID = this.getPatientInfo.appointment_id;
    //console.log("VerifypatientModule..." + this.VerifypatientModule.DOB)
    this._VerifypatientService.VerifyPatient_v1(this.VerifypatientModule).subscribe((res: any) => {
      this.spinner.hide();
      if (res.Data) {

        this.PatientPersonalInfo = res.Data as PatientPersonalInfo;
        this.PatientPersonalInfo.PRACTICE_CODE = this.VerifypatientModule.PRACTICE_CODE;
        this.PatientPersonalInfo.isShowpicture = true;
        this.PatientPersonalInfo.PracticeName = this.getPatientInfo.practiceName;
        this.PatientPersonalInfo.PROVIDER_CODE = this.getPatientInfo.providerCode;
        let data = this._phrutilService.encrypt(this.PatientPersonalInfo);

        //console.log("verii loc " + localStorage.getItem("AuthTokenwebServices"));
        localStorage.setItem('PersonalInfo', data);
        //localStorage.setItem("AuthToken", res.RESPONSE[0].ACCESS_TOKEN);
        localStorage.setItem('patientAccount', this.PatientPersonalInfo.PATIENT_ACCOUNT)
        localStorage.setItem('userName', this.PatientPersonalInfo.EMAIL_ADDRESS)
        this.updateinfoservice.onIsShowProfilePic();
        this._VerifypatientService.startRefreshTokenTimer();

        // if (this.isLockScreen) {
        //   localStorage.setItem("lockscreen", "true");
        //   this._router.navigateByUrl('/patient/consent-form');
        // }
        // else
        //   this._router.navigateByUrl('/patient/consent-form');
      } else {
        $("#incorrectinfo-model").modal("show");
      }
    }, (error: any) => {
      $("#incorrectinfo-model").modal("show");
      this.spinner.hide();
    }
    )

  }
  ConverttoLocalDate(date: any): string {
    // if (!date) return '';

    if (date instanceof Date) {
      date = this.hasTimezone(date) ? this.removeZ(date) : date;

      // date = moment(date).format('MM/DD/Y h:mm:ss');
      date = moment(date).format('MM/DD/YYYY');
      // date = new Date(date);
    }

    return date;
  }
  onlyCharAllow(event: any, type: any) {
    if (event.value.trim()) {
      let validname = event.value.replace(/[^a-zA-Z ]/g, "");
      event.value = validname;
    }
    else {
      event.value = event.value.trim();
      this.loginForm.controls[type].setValue(event.value);
    }
  }
  checkinBeforeThreeHours(visitDate: any, visitTime: any) {
    try {
      // Combine visitDate and visitTime into a single string
      const visitDateTimeStr = `${visitDate} ${visitTime}`;

      // Parse visit date and time into a Date object without converting to local timezone
      const visitDateTime = this.ConverttoLocalDateForDiff(visitDateTimeStr);
      //console.log("3 hour visit date time: " + visitDateTime);

      // Get the current date and time in UTC
      const currentDateTime = this.ConverttoLocalDateForDiff(new Date());
      //console.log("3 hour current date time: " + currentDateTime);

      // Calculate the difference in milliseconds
      const diffInMs = visitDateTime.getTime() - currentDateTime.getTime();

      // Convert the difference to hours
      const diffInHours = diffInMs / (1000 * 60 * 60);
      //console.log("3 hour difference: " + diffInHours);

      // Check if the difference is within 3 hours
      return diffInHours <= 3 && diffInHours >= 0;
    } catch (error) {
      //console.error("An error occurred while calculating the time difference:", error);
      // Return false if an error occurs
      return false;
    }

  }
  checkIfVisitWithin24Hours(visitDate: string, visitTime: string): boolean {

    const visitDateTime = this.ConverttoLocalDate(visitDate);
    //console.log("visit date time " + visitDateTime);
    //console.log("visit date time " + typeof visitDateTime);


    // const currentDateFormatted = this.getCurrentDateFormatted();
    // //console.log("current date with format " + currentDateFormatted)



    const currentDateTime = this.ConverttoLocalDate(new Date());
    //console.log("current date time " + currentDateTime);
    //console.log("current date time " + typeof currentDateTime);


    // Add one day to today's date
    const nextDay = this.ConverttoLocalDateInDay(new Date());
    nextDay.setDate(nextDay.getDate() + 1);



    const nextDaydate = this.ConverttoLocalDate(nextDay);
    //console.log("next day date " + nextDaydate);
    ////console.log("current date time " + typeof currentDateTime);

    if ((visitDateTime.trim() === currentDateTime.trim()) || (visitDateTime.trim() === nextDaydate.trim())) {
      return true;
    } else {
      return false;
    }

  }
  ConverttoLocalDateInDay(date: any): Date {
    // if (!date) return '';

    if (date instanceof Date) {
      date = this.hasTimezone(date) ? this.removeZ(date) : date;

      // date = moment(date).format('MM/DD/Y h:mm:ss');
      date = moment(date).format('MM/DD/YYYY');
      date = new Date(date);
    }

    return date;
  }
  ConverttoLocalDateForDiff(date: any): Date {
    // if (!date) return '';

    // if (date instanceof Date) {
    date = this.hasTimezone(date) ? this.removeZ(date) : date;

    date = moment(date).format('MM/DD/Y h:mm:ss');
    //date = moment(date).format('MM/DD/YYYY');
    date = new Date(date);

    // }

    return date;
  }
  private hasTimezone(value: any) {
    if (typeof value !== 'string') return false;
    return (value.includes('T') || value.includes('t'));
  }
  private removeZ(value: any) {
    if (!value) return '';
    return value.replace(/z|Z/, '');
  }
  getPaymentDetails() {
    this.spinner.show();
    this.service.getPaymentDetailsOld(this.patientpersonalinfo.practice_Code, this.patientpersonalinfo.patient_Account).subscribe((res: any) => {
      this.spinner.hide();
      this._phrutilService.setChekcinType("dob");
      if (res && res.statusCode == 200 && res.message == 'SUCCESS' && res.data) {
        this.paymentDetials = res as PaymentDeiails;
        this.amountDueTemp = Number(this.paymentDetials.data.totalAmount);

        // Check if amT_DUE is 0
        if (Number(this.paymentDetials.data.amT_DUE) <= 0) {
          this.isDobChecked = true;
          $("#No_due").modal("show");
          localStorage.removeItem('licensedata');
          return;
        }
        else {
          this._router.navigateByUrl("/payment-overview");
        }
        if (Number(this.paymentDetials.data.totalAmount) < 0 && this.paymentDetials.data.totalAmount.includes('-')) {
          this.isMinuTotalAmount = this.paymentDetials.data.totalAmount.replace('-', '');
          this.isMinuTotalAmount = Number(this.isMinuTotalAmount).toLocaleString();
        }
        if (Number(this.paymentDetials.data.amT_DUE) < 0 && this.paymentDetials.data.amT_DUE.includes('-')) {
          this.isMinuDueAmount = this.paymentDetials.data.amT_DUE.replace('-', '');
          this.isMinuDueAmount = Number(this.isMinuDueAmount).toFixed(2).toLocaleString();
        }
        this.paymentDetials.data.amT_DUE = Number(this.paymentDetials.data.amT_DUE).toFixed(2).toLocaleString();
        this.paymentDetials.data.totalAmount = Number(this.paymentDetials.data.totalAmount).toFixed(2).toLocaleString();
        if (Number(this.paymentDetials.data.currentDayAmount) > 0) {
          this.isCopay = true;
        } else {
          this.isCopay = false;
        }
        if (Number(this.paymentDetials.data.amT_DUE) > 0) {
          this.isoutstanding = true;
        } else {
          this.isoutstanding = false;
        }
        if (this.isCopay == true && this.isoutstanding == false) {
          this.ShowAmountField = false;
        }

      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
    });
  }

}
